import logo from './logo.svg';
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import '@fontsource/roboto';

import Box from '@mui/material/Box';
import GDPRBanner from './components/GDPRBanner';
import TopBarSection from './components/TopBarSection';
import HeroSection from './components/HeroSection';
import WhoIsSigmatiqaForSection from './components/WhoIsSigmatiqaForSection';
import MultiHeroPaginationSection from './components/MultiHeroPaginationSection';
import CompanyCaroselSection from './components/CompanyCaroselSection';
import DashboardSummarySection from './components/DashboardSummarySection';
import CaseStudyCalculatorSection from './components/CaseStudyCalculatorSection';
import StatementsSection from './components/StatementsSection';
import AccordianSection from './components/AccordianSection';
import GettingStartedSection from './components/GettingStartedSection';
import AppSection from './components/AppSection';
import ReportsSection from './components/ReportsSection';
import PricingSection from './components/PricingSection';
import GetInTouchSection from './components/GetInTouchSection';
import FooterSection from './components/FooterSection';
import AnimateSection from './components/AnimateSection';

const theme = createTheme({
});

function App() {
  return (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{margin: '0px'}}>
            <AnimateSection />
            {/* 
            <GDPRBanner />
            <TopBarSection />
            <HeroSection/>
            <WhoIsSigmatiqaForSection />
            <MultiHeroPaginationSection />
            <CompanyCaroselSection />
            <DashboardSummarySection />
            <CaseStudyCalculatorSection />
            <AccordianSection />
            <GettingStartedSection />
            <AppSection />
            <ReportsSection />
            <PricingSection />
            <GetInTouchSection />
            <FooterSection />
            */}
        </Box>
    </ThemeProvider>
  );
}

export default App;
